import { DistributionCenterInventoryHistory } from '@api/DistributionCenterInventoryHistory/DistributionCenterInventoryHistory';
import DistributionCenterInventoryHistoryServ from '@api/DistributionCenterInventoryHistory/DistributionCenterInventoryHistoryServ';

class DistributionCenterInventoryHistoryService {
    saveInventoryHistory = (
        inventoryHistory: DistributionCenterInventoryHistory
    ): Promise<DistributionCenterInventoryHistory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterInventoryHistoryServ.saveInventoryHistory(inventoryHistory);
                resolve(data);
            } catch (error) {
                reject('Error saving distribution center inventory history: ' + error);
            }
        });
    };
    getInventoryHistories = (distributionCenterId: string): Promise<DistributionCenterInventoryHistory[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterInventoryHistoryServ.getInventoryHistories(distributionCenterId);
                resolve(data);
            } catch (error) {
                reject('Error getting distribution center inventory histories: ' + error);
            }
        });
    };

    getInventoryHistory = (inventoryHistoryId: string): Promise<DistributionCenterInventoryHistory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterInventoryHistoryServ.getInventoryHistory(inventoryHistoryId);
                resolve(data);
            } catch (error) {
                reject('Error getting distribution center inventory history: ' + error);
            }
        });
    };
    deleteInventoryHistory = (inventoryHistoryId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DistributionCenterInventoryHistoryServ.deleteInventoryHistory(inventoryHistoryId);
                resolve();
            } catch (error) {
                reject('Error deleting distribution center inventory history: ' + error);
            }
        });
    };
}
export default DistributionCenterInventoryHistoryService;
